import { useEffect, type RefObject } from "react";
import { AMBIENT_PULSE_EVENT, type AmbientPulseDetail } from "@smartmanager/shell-ui/features/visualization/ambient/ambientField";

/** Window landings ripple across the floor from where the particle arrived. */
export function useAmbientPulseRings(fieldRef: RefObject<HTMLElement | null>, enabled = true) {
  useEffect(() => {
    const field = fieldRef.current;
    if (!enabled || !field) return;
    const onPulse = (event: Event) => {
      const { x, y } = (event as CustomEvent<AmbientPulseDetail>).detail;
      const ring = document.createElement("div");
      ring.className = "ambient-pulse";
      ring.style.left = `${x}px`;
      ring.style.top = `${y}px`;
      field.append(ring);
      const animation = ring.animate(
        [
          { transform: "translate(-50%, -50%) scale(0.06)", opacity: 0, easing: "ease-out" },
          { transform: "translate(-50%, -50%) scale(0.2)", opacity: 1, offset: 0.1, easing: "cubic-bezier(0.3, 0.5, 0.4, 1)" },
          { transform: "translate(-50%, -50%) scale(1)", opacity: 0 },
        ],
        { duration: 1600 },
      );
      animation.onfinish = () => ring.remove();
      animation.oncancel = () => ring.remove();
    };
    window.addEventListener(AMBIENT_PULSE_EVENT, onPulse);
    return () => window.removeEventListener(AMBIENT_PULSE_EVENT, onPulse);
  }, [enabled, fieldRef]);
}
